import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import { parseVehicle } from '@/vehicle/converters/vehicleConverters';
import AlarmCertificate from '../models/AlarmCertificate';
import DossierVehicle from '../models/DossierVehicle';
import ExtendedProperty from '../models/ExtendedProperty';
import Keybox from '../models/Keybox';

const ALARM_SCHEMA = {
  validTill: (data: any) => parseMoment(data.validTill),
};

const EXTENDED_PROPERTY_SCHEMA = {
  label: 'label',
  value: 'value',
};

const KEYBOX_SCHEMA = {
  id: 'id',
  locationReference: 'locationReference',
  locationDescription: 'locationDescription',
  isKeyAvailable: 'isDrop',
  actionOn: (data: any) => parseMoment(data.actionOn),
  actionBy: (data: any) => User.withFullName(data.actionBy),
};

const SCHEMA = {
  vehicle: (data: any) => parseVehicle(data.object),
  inspectionDate: (data: any) => parseMoment(data.motDate),
  alarmCertificateStatus: 'alarmCertificateStatus',
  alarmCertificates: (data: any) => parseAlarmCertificates(data.alarmCertificates),
  keybox: (data: any) => parseKeybox(data.keyboxInfo),
  extendedProperties: (data: any) => parseExtendedProperties(data.extendedProperties),
};

function parseAlarmCertificates(data: any): Array<AlarmCertificate> {
  return parseEntities(data, ALARM_SCHEMA, AlarmCertificate);
}

function parseKeybox(data: any): Keybox | null {
  return parseEntity(data, KEYBOX_SCHEMA, Keybox);
}

function parseExtendedProperties(data: any): Array<ExtendedProperty> {
  return parseEntities(data, EXTENDED_PROPERTY_SCHEMA, ExtendedProperty);
}

export function parseDossierVehicle(data: any): DossierVehicle | null {
  return parseEntity(data, SCHEMA, DossierVehicle);
}
